import { render, staticRenderFns } from "./OauthClientForm.vue?vue&type=template&id=e0df54cc"
import script from "./OauthClientForm.vue?vue&type=script&lang=js"
export * from "./OauthClientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports